var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70024 9.43333C7.10024 9.96667 7.90024 9.96667 8.30024 9.43333L13.8002 2.1C14.2947 1.44076 13.8243 0.5 13.0002 0.5H2.00024C1.1762 0.5 0.705817 1.44076 1.20024 2.1L6.70024 9.43333Z",
    fill: "currentColor"
  })));
};
export default SvgArrowDown;